import {
  Component,
  ChangeDetectionStrategy,
  Input,
  HostBinding,
  ChangeDetectorRef,
} from '@angular/core';

@Component({
  selector: 'app-sidebar-flyout',
  standalone: true,
  template: `
    <div class="flyout" role="presentation">
      <span class="flyout__label">{{ label }}</span>
    </div>
  `,
  styleUrl: './sidebar-flyout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarFlyoutComponent {
  private _label = '';
  @Input() set label(value: string) {
    if (value !== this._label) {
      this._label = value;
      this.cdr.markForCheck();
    }
  }
  get label() {
    return this._label;
  }
  @HostBinding('attr.aria-hidden') ariaHidden = true;
  constructor(private cdr: ChangeDetectorRef) {}
}
